"use strict";

Shopify.theme.jsFeaturedLinksSlider = {
  init: function init($section) {
    const $sliderCount = $section.find('[data-slide-index]').length;
    const $featuredLinksSliderEl = $(document).find('[data-featured-links-slider]');
    const $prevButton = $section.find('.featured-links-slider__nav--prev');
    const $nextButton = $section.find('.featured-links-slider__nav--next');
    const $headingWrapper = $section.find('.featured-links-slider__header');
    const $leftOffset = ($headingWrapper.parent().innerWidth() -  $headingWrapper.width()) / 2;
    
    const $featuredLinksSlider = $featuredLinksSliderEl.flickity({
      wrapAround: $sliderCount > 4,
      prevNextButtons: false,
      pageDots: true,
      imagesLoaded: true,
      lazyLoaded: $sliderCount > 4,
      draggable: $sliderCount > 4,
      cellAlign: $leftOffset / $featuredLinksSliderEl.innerWidth(),
      on: {
        ready: function ready() {
          setTimeout(function () {
            $featuredLinksSlider.flickity('resize');
          }, 500);
        }
      }
    });
    // Change slide on previous nav button click
    $prevButton.on('click', function () {
      $featuredLinksSlider.flickity('previous');
    });
    // Change slide on next nav button click
    $nextButton.on('click', function () {
      $featuredLinksSlider.flickity('next');
    });
  },
  unload: function unload($section) {
    var $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
    $('.featured-links-slider__nav--prev').off();
    $('.featured-links-slider__nav--next').off();
  }
};